import { Box } from "@mui/material";
import { MenuItem, Select } from "@platform/design-system";

import type { CarrierSort } from "../types";

const SORT_OPTIONS: { value: CarrierSort; label: string }[] = [
  { value: "most-rfps", label: "Most RFPs" },
  { value: "a-z", label: "A-Z" },
];

const renderSortValue = (selected: unknown): React.ReactNode => (
  <Box display="grid">
    {SORT_OPTIONS.map(({ value, label }) => (
      <Box
        key={value}
        gridArea="1 / 1"
        visibility={value === selected ? "visible" : "hidden"}
      >
        {label}
      </Box>
    ))}
  </Box>
);

export const CarrierSortSelect = (): React.JSX.Element => (
  <Select defaultValue="most-rfps" renderValue={renderSortValue}>
    {SORT_OPTIONS.map(({ value, label }) => (
      <MenuItem key={value} value={value}>
        {label}
      </MenuItem>
    ))}
  </Select>
);
